import './style.scss';
import { useNoticeDetail } from './hooks';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { NotificationListItem } from '../notice/module/notificationList';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { LoadingContainer } from 'views/mutual/loading';
import { NotFoundData, NotFoundDataBackPageType } from 'views/mutual/notFoundData';
import { PagePath } from 'constants/pagePath';
import { DateFormatType, formatDate } from 'views/utils/converter';

export type NoticeDetailLocationState = {
  previousPage?: string;
};

export const NoticeDetail = () => {
  const location = useLocation();
  const locationState = location.state as NoticeDetailLocationState;
  const { id } = useParams<{ id: string }>();
  const { notificationInfo, submitProps } = useNoticeDetail({
    id: id || '',
    previousPage: locationState?.previousPage,
  });

  if (!notificationInfo.fetching && !notificationInfo.data?.GetNotificationInfo) {
    return (
      <NotFoundData
        backPageType={{
          kind: 'previous',
        }}
      />
    );
  }

  return (
    <div className="noticeDetail">
      <LoadingContainer isLoading={notificationInfo.fetching}>
        {notificationInfo.data?.GetNotificationInfo && (
          <>
            <NotificationListItem
              itemIndex={1}
              notification={notificationInfo.data.GetNotificationInfo}
              isDetail={true}
              previousPage=""
            />
            <span className="noticeDetail_letter">{notificationInfo.data.GetNotificationInfo.Contents}</span>
            <div className="noticeDetail_footer">
              <div>
                {notificationInfo.data?.GetNotificationInfo?.ConfirmDateTime ? (
                  <>
                    確認日：
                    {formatDate(
                      new Date(notificationInfo.data?.GetNotificationInfo?.ConfirmDateTime),
                      DateFormatType.Slash_yyyyMMdd,
                    )}
                  </>
                ) : (
                  ''
                )}
              </div>
              <Button
                type={ButtonType.Submit}
                label={submitProps.label}
                buttonFill={ButtonFill.black}
                buttonSize={ButtonSize.medium}
                onClick={submitProps.onClick}
              />
            </div>
          </>
        )}
      </LoadingContainer>
    </div>
  );
};
